import React from 'react';

const RightArrowNav = ({ size = 14, rotate = 'right', ...props }) => {
  const getRotateDeg = (val) => {
    switch (val) {
      case 'down':
        return '90';
      case 'left':
        return '180';
      case 'up':
        return '270';
      default:
        return '0';
    }
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 15 15"
      fill="none"
      style={{
        transform: `rotate(${getRotateDeg(rotate)}deg)`,
        transition: '300ms linear all',
      }}
      xmlSpace="preserve"
      {...props}
    >
      <path
        d="M5.56641 12.4501L9.64141 8.37505C10.1227 7.8938 10.1227 7.1063 9.64141 6.62505L5.56641 2.55005"
        stroke="currentColor"
        strokeWidth="1.875"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RightArrowNav;
